import { InputConfig, validateEmail, validateWebsite } from "@cpj-ai/panel-npm-package";
import TermOfUseLabel from "./TermOfUseLabel";

export const inputConfigs: InputConfig[] = [
  {
    name: "name",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Organization Name",
      placeholder: "Ex : Canada prime jobs",
    },
    rules: {
      required: "This field is required",
    },
  },
  {
    name: "email",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Organization Email",
      placeholder: "Ex : admin@cpj.com",
    },
    rules: {
      required: "This field is required",
      validate: (value) => {
        const emailResult = validateEmail(value);
        return emailResult.isValid ? true : emailResult.message;
      },
    },
  },
  {
    name: "website",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Organization Web URL",
      placeholder: "Ex : www.cpj.ai",
    },
    rules: {
      required: "This field is required",
      validate: (value) => {
        const websiteResult = validateWebsite(value);
        return websiteResult.isValid ? true : websiteResult.message;
      },
    },
  },
  {
    name: "termsOfUse",
    previewSize: 12,
    inputProps: {
      type: "checkbox",
      label: <TermOfUseLabel />,
    },
    rules: {
      required: "You must agree to the terms of use",
    },
  },
];
